module.exports = __webpack_public_path__ + "f6dd5092e67f98f12fd495d160bd094d.png";